import { render } from "./PeoplePaperPractice.vue?vue&type=template&id=b3054874&scoped=true"
import script from "./PeoplePaperPractice.vue?vue&type=script&lang=js"
export * from "./PeoplePaperPractice.vue?vue&type=script&lang=js"

import "./PeoplePaperPractice.vue?vue&type=style&index=0&id=b3054874&scoped=true&lang=css"

import exportComponent from "E:\\project\\exam\\web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b3054874"]])

export default __exports__